<template>
  <v-card class="create-volume">
    <v-card-title>
      {{ $t('volume.create_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field outlined
                      :label="$t('volume.name')"
                      v-model="result.name"
                      :rules="requiredRules"></v-text-field>
        <v-text-field outlined
                      :label="$t('volume.order_no')"
                      v-model="result.order_no"
                      type="number"
                      min="1"
                      :rules="requiredRules"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && save()"
             depressed
             large>
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'CreateVolumeDialog',
  props: {
    sorId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);

    const result = ref({
      name: '',
      order_no: null,
    })

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/volume/create/',
        params: {
          ...result.value,
          sor_id: props.sorId,
        }
      });

      if (response.body.success) {
        emit('submit', true)
      }
    }

    return {
      requiredRules,
      result,
      save,
    }
  },
}
</script>
